<ion-content>
  <ion-list>
    <ion-item (click)="select('lfAlle')">
      <ion-icon slot="start" [name]="historieFilter === 'lfAlle' ? 'checkbox-outline' : 'square-outline'"></ion-icon>
      <ion-label>
        Alle
      </ion-label>
    </ion-item>
    <ion-item-divider>
      Lieferdatum
    </ion-item-divider>
    <ion-item (click)="select('lfHeute')">
      <ion-icon slot="start" [name]="historieFilter === 'lfHeute' ? 'checkbox-outline' : 'square-outline'"></ion-icon>
      <ion-label>
        Heute
      </ion-label>
    </ion-item>
    <ion-item (click)="select('lfGestern')">
      <ion-icon slot="start" [name]="historieFilter === 'lfGestern' ? 'checkbox-outline' : 'square-outline'"></ion-icon>
      <ion-label>
        Gestern
      </ion-label>
    </ion-item>
    <ion-item-divider>
      Bestelldatum
    </ion-item-divider>
    <ion-item (click)="select('beHeute')">
      <ion-icon slot="start" [name]="historieFilter === 'beHeute' ? 'checkbox-outline' : 'square-outline'"></ion-icon>
      <ion-label>
        Heute
      </ion-label>
    </ion-item>
    <ion-item (click)="select('beGestern')">
      <ion-icon slot="start" [name]="historieFilter === 'beGestern' ? 'checkbox-outline' : 'square-outline'"></ion-icon>
      <ion-label>
        Gestern
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
